import type { ApiClientError } from 'api/client';

export type OboOutcome =
  | 'reauth_required'
  | 'pending_approval'
  | 'mint_blocked'
  | 'not_admin'
  | 'connection_failed'
  | 'temporarily_blocked'
  | 'unsupported_asset'
  | 'error';

export function oboOutcomeMessageKey(outcome?: string): string {
  switch (outcome) {
    case 'reauth_required':
      return 'newSocialMediaProfile.oboOutcome.reauthRequired';
    case 'pending_approval':
      return 'newSocialMediaProfile.oboOutcome.pendingApproval';
    case 'mint_blocked':
      return 'newSocialMediaProfile.oboOutcome.mintBlocked';
    case 'not_admin':
      return 'newSocialMediaProfile.oboOutcome.notAdmin';
    case 'connection_failed':
      return 'newSocialMediaProfile.oboOutcome.connectionFailed';
    case 'temporarily_blocked':
      return 'newSocialMediaProfile.oboOutcome.temporarilyBlocked';
    case 'unsupported_asset':
      return 'newSocialMediaProfile.oboOutcome.unsupportedAsset';
    default:
      return 'newSocialMediaProfile.oboOutcome.generic';
  }
}

export function oboOutcomeHelpUrl(outcome?: string): string | undefined {
  switch (outcome) {
    case 'not_admin':
      return 'https://help.kontentino.com/en/articles/16019612-setting-up-meta-business-portfolio-access-for-safe-connect';
    default:
      return undefined;
  }
}

// axios's codes for a request it stopped waiting for (0.21: ECONNABORTED,
// or ETIMEDOUT with `transitional.clarifyTimeoutError`).
const CLIENT_TIMEOUT_CODES = ['ECONNABORTED', 'ETIMEDOUT'];

/**
 * The web app gave up waiting for the confirm (SAFE_CONNECT_CONFIRM_TIMEOUT).
 * Not a refusal, but the pages are not reliably created either: the warning
 * asks the person to connect again.
 */
export function isClientTimeout(error?: ApiClientError | null): boolean {
  const code = error?.axiosError?.code;

  return !!code && CLIENT_TIMEOUT_CODES.includes(code);
}
